var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "applicationManager" } },
    [
      _c(
        "div",
        {
          staticClass: "wrap-content",
          class: { "wrap-content-long": !_vm.is_sidebar_minimized }
        },
        [
          _c("div", { staticClass: "header-page header-page-group" }, [
            _c(
              "div",
              {
                staticClass: "d-flex justify-content-between align-items-center"
              },
              [
                _c("div", { staticClass: "d-flex align-items-center" }, [
                  _c("img", {
                    staticClass: "back-to-list",
                    attrs: { src: require("@/assets/icon/arrow-left.svg") },
                    on: {
                      click: function($event) {
                        _vm.$router.go(-1)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm.isLoading
                    ? _c("div", {
                        staticClass: "skeleton-box",
                        staticStyle: {
                          width: "100px",
                          height: "30px",
                          "margin-bottom": "0 !important"
                        }
                      })
                    : _c("h3", { staticClass: "application-name" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.groupName) +
                            "\n          "
                        )
                      ])
                ]),
                _vm._v(" "),
                _c("i", {
                  staticClass: "fa fa-ellipsis-v fa-lg popover-config",
                  attrs: { id: "popover-config-menu" }
                })
              ]
            ),
            _vm._v(" "),
            _vm._m(0)
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "application-content" }, [
            _c(
              "div",
              {
                staticClass: "card-content mb-4",
                staticStyle: { width: "80%" }
              },
              [
                _c("p", { staticClass: "card-title" }, [_vm._v("Properties")]),
                _vm._v(" "),
                _vm.isLoading
                  ? _c("div", [
                      _c("div", {
                        staticClass: "skeleton-box",
                        staticStyle: { height: "40px" }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "skeleton-box",
                        staticStyle: { height: "120px" }
                      })
                    ])
                  : _c(
                      "div",
                      [
                        _c(
                          "b-form-group",
                          {
                            class: { "error-input": _vm.$v.group.name.$error }
                          },
                          [
                            _c("label", [_vm._v(" Group Name ")]),
                            _vm._v(" "),
                            _c("j-input", {
                              attrs: { placeholder: "Enter group name here" },
                              model: {
                                value: _vm.$v.group.name.$model,
                                callback: function($$v) {
                                  _vm.$set(_vm.$v.group.name, "$model", $$v)
                                },
                                expression: "$v.group.name.$model"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          {
                            class: {
                              "error-input": _vm.$v.group.description.$error
                            }
                          },
                          [
                            _c("label", [_vm._v(" Description ")]),
                            _vm._v(" "),
                            _c("j-textarea", {
                              attrs: {
                                disabled: false,
                                placeholder: "Enter group description here"
                              },
                              model: {
                                value: _vm.$v.group.description.$model,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.$v.group.description,
                                    "$model",
                                    $$v
                                  )
                                },
                                expression: "$v.group.description.$model"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "d-flex justify-content-end" },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "button-blue",
                                on: { click: _vm.updateGroup }
                              },
                              [_vm._v("\n              Update\n            ")]
                            )
                          ]
                        )
                      ],
                      1
                    )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card-content", staticStyle: { width: "80%" } },
              [
                _c("p", { staticClass: "card-title" }, [_vm._v("Application")]),
                _vm._v(" "),
                _vm.isLoading ? _c("jLoadingTable") : _vm._e(),
                _vm._v(" "),
                _c(
                  "v-client-table",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.isLoading,
                        expression: "!isLoading"
                      }
                    ],
                    staticClass: "jTable group-application-table",
                    attrs: {
                      data: _vm.dataApps,
                      columns: _vm.columns,
                      options: _vm.tableOptions
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "id",
                        fn: function(props) {
                          return _c("div", {}, [
                            _vm._v(
                              "\n            " +
                                _vm._s(props.row.id) +
                                "\n          "
                            )
                          ])
                        }
                      },
                      {
                        key: "icon",
                        fn: function(props) {
                          return _c("div", {}, [
                            props.row.icon
                              ? _c("img", {
                                  attrs: { src: props.row.icon, width: "32" }
                                })
                              : _vm._e()
                          ])
                        }
                      },
                      {
                        key: "name",
                        fn: function(props) {
                          return _c("div", {}, [
                            _vm._v(
                              "\n            " +
                                _vm._s(props.row.name) +
                                "\n          "
                            )
                          ])
                        }
                      },
                      {
                        key: "delete",
                        fn: function(props) {
                          return _c("div", {}, [
                            _c("i", {
                              staticClass: "fa fa-trash fa-lg cursor-pointer",
                              on: {
                                click: function($event) {
                                  _vm.deleteMapping(props.row.id)
                                }
                              }
                            })
                          ])
                        }
                      }
                    ])
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "custom-search",
                        attrs: { slot: "beforeFilter" },
                        slot: "beforeFilter"
                      },
                      [
                        _c(
                          "b-form",
                          { attrs: { inline: "" } },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "btn grey btn-import-form m__r--5",
                                on: {
                                  click: function($event) {
                                    _vm.isModalAppOpen(true)
                                  }
                                }
                              },
                              [
                                _c("i", { staticClass: "fa fa-plus fa-lg" }),
                                _vm._v(" Add\n              ")
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form",
                              {
                                attrs: { inline: "" },
                                on: {
                                  keypress: function($event) {
                                    if (
                                      !("button" in $event) &&
                                      $event.keyCode !== 13
                                    ) {
                                      return null
                                    }
                                    $event.preventDefault()
                                    _vm.filter(_vm.filterData)
                                  }
                                }
                              },
                              [
                                _c("j-select", {
                                  staticClass: "m__r--5",
                                  attrs: {
                                    options: _vm.optionsSearch,
                                    placeholder: "Filter By"
                                  },
                                  model: {
                                    value: _vm.selectType,
                                    callback: function($$v) {
                                      _vm.selectType = $$v
                                    },
                                    expression: "selectType"
                                  }
                                }),
                                _vm._v(" "),
                                _c("b-form-input", {
                                  staticStyle: {
                                    width: "250px",
                                    height: "35px"
                                  },
                                  attrs: { placeholder: "Search" },
                                  model: {
                                    value: _vm.filterData,
                                    callback: function($$v) {
                                      _vm.filterData = $$v
                                    },
                                    expression: "filterData"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "b-popover",
        {
          ref: "configPopoverRef",
          attrs: { target: "popover-config-menu", placement: "left" }
        },
        [
          _c(
            "div",
            { staticClass: "form-ui-opt", on: { click: _vm.deleteGroup } },
            [_vm._v("\n      Delete Group\n    ")]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "appModal",
          staticClass: "mod-form modal-app-type",
          attrs: {
            centered: "",
            "no-close-on-esc": "",
            "no-close-on-backdrop": ""
          }
        },
        [
          _c("j-modal-mapping-apps-group", {
            on: {
              "modal-open": _vm.isModalAppOpen,
              "data-created": _vm.getGroupApplicationList
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tabs" }, [
      _c("div", { staticClass: "tab-list tab-active" }, [_vm._v("GENERAL")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-45fe67a6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45fe67a6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/application-manager/detail/jAppManagerDetailGroup.vue
// module id = null
// module chunks = 